import { create } from 'zustand'
import type { Document } from '@/types/document'

interface DocumentState {
  documents: Document[]
  selectedDocument: Document | null
  loading: boolean
  error: string | null
  refreshTrigger: number

  setDocuments: (documents: Document[]) => void
  setSelectedDocument: (document: Document | null) => void
  updateDocument: (document: Document) => void
  removeDocument: (id: number) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  triggerRefresh: () => void
}

export const useDocumentStore = create<DocumentState>((set) => ({
  documents: [],
  selectedDocument: null,
  loading: false,
  error: null,
  refreshTrigger: 0,

  setDocuments: (documents) => set({ documents }),

  setSelectedDocument: (document) => set({ selectedDocument: document }),

  updateDocument: (document) =>
    set((state) => ({
      documents: state.documents.map((d) =>
        d.id === document.id ? document : d
      ),
      selectedDocument:
        state.selectedDocument?.id === document.id
          ? document
          : state.selectedDocument,
    })),

  removeDocument: (id) =>
    set((state) => ({
      documents: state.documents.filter((d) => d.id !== id),
      selectedDocument:
        state.selectedDocument?.id === id ? null : state.selectedDocument,
    })),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  triggerRefresh: () => set((state) => ({ refreshTrigger: state.refreshTrigger + 1 })),
}))
